import { Tooltip } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import { MedicationType } from '../Contracts/MedicationModels';
import { heading } from '../Styles/Colours';
import styles from './MedicationCard.module.css';
export var MedicationCardMode;
(function (MedicationCardMode) {
    MedicationCardMode["Standard"] = "standard";
    MedicationCardMode["Condensed"] = "condensed";
    MedicationCardMode["SingleLine"] = "singleLine";
    MedicationCardMode["Long"] = "long";
})(MedicationCardMode || (MedicationCardMode = {}));
export var MedicationCard = function (props) {
    var _a, _b, _c, _d;
    var selected = props.selected;
    var condensed = props.mode === MedicationCardMode.Condensed;
    var standard = props.mode === MedicationCardMode.Standard;
    var long = props.mode === MedicationCardMode.Long;
    var productInformationClasses = classNames(styles.productInformation, (_a = {},
        _a[styles.selected] = selected,
        _a[styles.singleLine] = true,
        _a));
    var productPackNameClasses = classNames(styles.productPackName, (_b = {},
        _b[styles.condensed] = condensed,
        _b));
    var productPackInfoClasses = classNames(styles.productPackInfo, (_c = {}, _c[styles.condensed] = condensed, _c));
    var containerClasses = classNames(styles.container, (_d = {},
        _d[styles.selected] = selected,
        _d[styles.expandedContainer] = standard,
        _d[styles.longContainer] = long,
        _d));
    var packSize = props.isNonStandardPackSize ? props.nonStandardPackSize : props.size;
    var strengthLabel = props.strength + " " + (props.strengthUnit ? props.strengthUnit : '');
    var amountLabel = "(" + props.productPackAmount + " x " + packSize + ")";
    if (props.type === MedicationType.TakeHomeScript &&
        props.repeatsAmount !== undefined &&
        props.repeatsAmount !== null) {
        amountLabel = amountLabel + (" \u00B7 Rpts: " + props.repeatsAmount);
    }
    return (React.createElement("div", { className: containerClasses },
        React.createElement("div", { className: productInformationClasses },
            React.createElement("div", { className: productPackNameClasses, style: { color: heading } },
                React.createElement(Tooltip, { title: props.name, placement: 'bottom-start' },
                    React.createElement("span", null, props.name))))));
};
